export const environment = {
  production: true,
  supabaseUrl: 'https://qgbwjkjgnyaynctlqxvq.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFnYndqa2pnbnlheW5jdGxxeHZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5MTk1MDcsImV4cCI6MjA5MTQ5NTUwN30.ZQ93zybOTgslF7VsZDZP2B2thpdolNLW0lO_3Dqz4FQ'
};
